import { MediaLabel, PlayStatus } from '../../learnware/LearnwareEnums';
export class AskingMedia {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get appImpact() {
        return this.parent;
    }
    get app() {
        return this.appImpact.app;
    }
    get relevantIntents() {
        if (!this.app.answer)
            return [];
        return this.app.mediaPlayer.channelVoice.intents.filter(intent => intent.answerId === this.app.answer.id);
    }
    latestEventOfLabel(label) {
        return this.relevantIntents.find(intent => intent.mediumLabel === label);
    }
    get hatFragestellungVorgelesen() {
        return (this.relevantIntents.filter(intent => intent.mediumLabel === MediaLabel.questionpart && [PlayStatus.Ended, PlayStatus.Aborted].includes(intent.playStatus)).length > 0);
    }
}
